import InformationList from '@/src/components/common/InformationList'
import { useDispensing } from '@/src/hooks'
import { capitalizeDrugName, getIncludedData } from '@/src/utils'
import { Loader, SideDrawer } from '@ui'
import { Box } from 'grommet'
import moment from 'moment'
import { useMemo, useState } from 'react'

type Props = {
  onClose: () => void
  id?: string
}

const options = ['Order Details', 'Note']

export const DispenseDetail = ({ onClose, id }: Props) => {
  const { singleDispense, dispenseIsLoading } = useDispensing({ id })
  const { data, included } = singleDispense ?? {}
  const [tab, setTab] = useState('Order Details')

  const details = useMemo(() => {
    if (data && included) {
      const {
        attributes: { dispensary_type, medication_details, created_at },
        relationships: { bed, patient, unit, product_inventory, room }
      } = data
      const { first_name, last_name } = getIncludedData(included, 'patient', patient.data?.id).attributes
      return {
        'Bed number': getIncludedData(included, 'bed', bed?.data?.id)?.attributes?.room || '--',
        ID: getIncludedData(included, 'product_inventory', product_inventory.data?.id).attributes?.batch_number,
        Medication: capitalizeDrugName(
          getIncludedData(included, 'product_inventory', product_inventory.data?.id).attributes?.drug_name
        ),

        'Patient name': `${first_name} ${last_name}`,
        'Room number': getIncludedData(included, 'room', room?.data?.id)?.attributes?.room || '--',
        Unit: getIncludedData(included, 'bed', unit?.data?.id)?.attributes?.room || '--',
        ...(dispensary_type !== 'outpatient_DAP' && { 'Next Dosage': medication_details.next_dosage_at }),
        'Prescribed by': '--',
        Time: moment(created_at).format('DD/MM/YYYY h:mm A')
      }
    }
    return {}
  }, [included, data])
  return (
    <SideDrawer onClose={onClose} title="Details">
      {dispenseIsLoading ? (
        <Loader />
      ) : (
        <Box flex style={{ overflow: 'hidden', position: 'relative' }}>
          <div
            className={`step-slide ${tab === 'Order Details' ? 'active' : ''} px-5`}
            style={{
              position: 'absolute',
              transform: `translateX(${tab === 'Order Details' ? '0' : '-100%'})`,
              transition: 'all 0.3s ease-in-out',
              width: '100%'
            }}
          >
            <InformationList data={details} />
          </div>
          <div
            className={`step-slide ${tab === 'Note' ? 'active' : ''} px-5`}
            style={{
              bottom: '0px',
              position: 'absolute',
              top: '0px',
              transform: `translateX(${tab === 'Note' ? '0' : tab === 'Order Details' ? '100%' : '-100%'})`,
              transition: 'all 0.3s ease-in-out',
              width: '100%'
            }}
          >
            <Box className="px-3">
              <p className="text-sm">{data?.attributes.note}</p>
            </Box>
          </div>
        </Box>
      )}
    </SideDrawer>
  )
}
